<div class="container-full" style="margin-top:15px;">
    <div class="ace-heading-banner">
        <div style="padding-top:18px;">
            <span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">Flash PARCS Sync</span>
         </div>
    </div>
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        </mat-card-header>
        <mat-card-content>
@if(loadingMessage){
    <app-processing-banner [WaitMessage]="loadingMessage"></app-processing-banner>
}

<button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;width:300px;" (click)="getSyncDataForLot(_appGeneralStateService.currentLotNumber)">Get Parker/PARCS Sync Data</button>
<button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;width:300px;" (click)="onGetCurrentFlashData()">Get Current Flash Data</button>
<hr />

@if(!loadingMessage) {
    @if(syncData && syncData.length == 0){
        <p>No sync data available.</p>
    }
    @else if(syncData && syncData.length > 0)
    {
        <div class="row" style="margin-top:10px;margin-bottom:20px;">
            <div class="col-4">
                <div style="font-size:18px;font-weight: bold;">Select View</div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [(value)]="selectedSyncStatusToggle" (change)="onViewChange($event.value)" hideSingleSelectionIndicator="true">
                        <mat-button-toggle value="all">
                            <mat-icon style="color: black; margin-right: 8px;">list</mat-icon>
                            All @if(selectedSyncStatusToggle === 'all'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="synced">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">sync</mat-icon>
                            Synced @if(selectedSyncStatusToggle === 'synced'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="ready">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">sync</mat-icon>
                            Ready @if(selectedSyncStatusToggle === 'ready'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="review">
                            <mat-icon style="margin-right: 8px;">edit</mat-icon>
                            Review @if(selectedSyncStatusToggle === 'review'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="unable">
                            <mat-icon style="color: #f44336; margin-right: 8px;">block</mat-icon>
                            Unable @if(selectedSyncStatusToggle === 'unable'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="applied">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">done_all</mat-icon>
                            Sync Applied @if(selectedSyncStatusToggle === 'applied'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                </mat-button-toggle-group>
                <br />
                <br />
                <span>{{syncStatusDescription}}</span>
                <br />

                @if(selectedSyncStatusToggle == 'ready'){
                <button type="button" class="btn btn-primary mt-3 ace-blue"
                    style="margin-left:0px;width:300px;"
                    (click)="onSyncNowParkerToParcs()">Sync All Matched Parkers</button>
                }

                @if(selectedSyncStatusToggle == 'synced'){
                <button type="button" class="btn btn-primary mt-3 ace-blue"
                    style="margin-left:0px;width:300px;"
                    (click)="onSyncNowSyncMatchedParkers()">Update All Synced Parkers</button>
                }
            </div>
             <div class="col-2">
            </div>
            <div class="col-6">
                <br />
                <span><strong>Discrepancy Analysis</strong></span><br />
                <span>spACE AR Parkers: {{this.numberOfParkersFound}}</span><br />
                <span>Flash Accounts: {{this.numberOfFlashAccountsFound}}</span><br />
            </div>

            <br /><br />
            <div class="col-12">
                <mat-icon style="color:green;font-size: 36px; width: 36px; height: 36px;position:relative;top:15px;">announcement</mat-icon> &nbsp;&nbsp;<span><strong>Data reflected in spACE AR will update the Flash information for each account</strong></span>
            </div>
        </div>
        <div>
        </div>
       <ng-container *ngIf="displaySyncData && displaySyncData.length > 0">
       <igx-grid #gridFlashParkerSync id="gridFlashParkerSync" [data]="this.displaySyncData" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
            paste-handler  [primaryKey]="'parkerAccountNumberId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact"
            [emptyGridMessage]="'Parker Flash Sync Data'"  [clipboardOptions]="options" paste-handler>

         <igx-column field="" width="50px" required>
            <ng-template igxHeader>
            </ng-template>
            <ng-template igxCell let-cell="cell" let-value>
                @if (cell.row.data.status == 0) {
                     <div style="position:relative; top: -5px;">
                        <mat-icon matTooltip="Ready for Sync" style="font-size: 24px; width: 25px; height: 25px; color: #093d0a;">sync</mat-icon>
                     </div>
                }
                @if (cell.row.data.status == 1) {
                     <div style="position:relative; top: -5px;">
                        <mat-icon matTooltip="Edit Parker/Flash" style="font-size: 24px; width: 25px; height: 25px; color: black;">edit</mat-icon>
                     </div>
                }
                @if (cell.row.data.status == 2) {
                     <div style="position:relative; top: -5px;">
                        <mat-icon matTooltip="No Matching Flash Contact" style="font-size: 24px; width: 25px; height: 25px; color: red;">block</mat-icon>
                     </div>
                }
                @if (cell.row.data.status == 3) {
                     <div style="position:relative; top: -5px;">
                        <mat-icon matTooltip="No Matching Parker" style="font-size: 24px; width: 25px; height: 25px; color: #f44336;">block</mat-icon>
                     </div>
                }
                @if (cell.row.data.status == 10) {
                     <div style="position:relative; top: -5px;">
                        <mat-icon matTooltip="Synced" style="font-size: 24px; width: 25px; height: 25px; color: green;">done_all</mat-icon>
                     </div>
                }
            </ng-template>
        </igx-column>

        <igx-column field="parkerCardNumber" [sortable]="true" width="200px" required>
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">spACE AR Parkers</span><br />Card No
            </ng-template>
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.cardNumbersDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    {{ value || '' }}
                </div>
            </ng-template>
        </igx-column>

        <igx-column field="parkerFullName" header="Parker" width="200px" required [sortable]="true">
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.parkerNameDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    <a matButton href="javascript:void(0)"
                    class="mimic-button-hover"
                     (click)="onCopyMessage('Parker Id copied to clipboard')"
                     [cdkCopyToClipboard]="cell.row.data.spaceArParkerId"
                    >{{value}}</a>
                </div>
            </ng-template>
        </igx-column>

        <igx-column field="parkerCompanyName" header="Company" width="200px" required [sortable]="true">
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.companyNameDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    {{ value || '' }}
                </div>
            </ng-template>
        </igx-column>

        <igx-column field="parkerStartDate" header="Start Date" width="125" required [sortable]="true">
             <ng-template igxCell let-cell="cell" let-value>
                @if(value && value !== '' && value !== '0001-01-01T00:00:00') {
                    {{ value | date:'shortDate' }}
                }
                @else {
                    --
                }
            </ng-template>
        </igx-column>

        <igx-column field="parkerEndDate" header="End Date" width="125" required [sortable]="true">
            <ng-template igxCell let-cell="cell" let-value>
                @if(value && value !== '' && value !== '0001-01-01T00:00:00') {
                    {{ value | date:'shortDate' }}
                }
                @else {
                    --
                }
            </ng-template>
        </igx-column>

        <igx-column field="" header="" width="20px" required [sortable]="false">
            <ng-template igxCell let-cell="cell" let-value>
                    {{ value || '' }}
            </ng-template>
        </igx-column>

        <igx-column field="flashRfidNumber" [sortable]="true" width="200px" required>
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">Flash Accounts</span><br />RFID Tag
            </ng-template>
        </igx-column>

        <igx-column field="flashFullName" header="Flash Contact" width="200px" required [sortable]="true"></igx-column>

        <igx-column field="flashCompanyName" header="Company" width="200px" required [sortable]="true"></igx-column>

        <igx-column field="flashAccountNumber" [sortable]="true" width="200px" required>
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">Account Number</span>
            </ng-template>
        </igx-column>

        <igx-column field="flashMonthlyAccountGuid" [sortable]="true" width="250px" required>
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">Monthly Account Guid</span>
            </ng-template>
        </igx-column>

<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>

</ng-container>

        <ng-container *ngIf="displaySyncData && displaySyncData.length == 0">
            <strong>No Parker sync data available for the selected view.</strong>
        </ng-container>
    }
}
</mat-card-content>
</mat-card>
</div>
